/* ZONAPLAY — lógica de tienda (carrito Shopify AJAX, filtros, variantes, modales) */
(function () {
    'use strict';

    var $ = function (s, c) { return (c || document).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

    function money(cents) {
        var p = (cents / 100).toFixed(2).split('.');
        return '$ ' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
    }
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    /* ---------- Toast ---------- */
    var toastTimer;
    function toast(msg) {
        var t = $('#toast-notification'); if (!t) return;
        $('#toast-message').textContent = msg;
        t.classList.add('show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
    }

    /* Respaldo de imagen: si el producto no tiene foto en Shopify, usa la incluida en el tema */
    function fallbackImg(it) {
        var base = window.ZP_ASSET_BASE || 'assets/';
        var name = it.handle || '';
        if (name === 'dualsense-wireless-controller') {
            var c = (it.variant_title || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            name = 'dualsense-' + c;
        }
        return base + name + '.jpg';
    }
    /* ---------- Carrito ---------- */
    var drawer = $('#cart-drawer');
    function openCart() { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; renderCart(); }
    function closeCart() { drawer.classList.remove('open'); document.body.style.overflow = ''; }

    function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

    function updateCount(cart) {
        var c = $('#cart-count'); if (!c) return;
        c.textContent = cart.item_count;
        c.classList.add('bump'); setTimeout(function () { c.classList.remove('bump'); }, 220);
    }

    function renderCart() {
        fetchCart().then(function (cart) {
            updateCount(cart);
            var box = $('#cart-items-container');
            if (!cart.items.length) {
                box.innerHTML = '<div class="cart-empty">🎮<br>Tu carrito está vacío.<br>¡Sumá algo para jugar!</div>';
            } else {
                box.innerHTML = cart.items.map(function (it, i) {
                    return '<div class="cart-item">' +
                        '<img src="' + esc(it.image || fallbackImg(it)) + '" alt="' + esc(it.product_title) + '">' +
                        '<div><div class="cart-item-name">' + esc(it.product_title) +
                        (it.variant_title ? ' <span style="color:#6b7488;font-weight:500">· ' + esc(it.variant_title) + '</span>' : '') + '</div>' +
                        '<div class="cart-item-price">' + money(it.final_line_price) + '</div>' +
                        '<div class="cart-qty"><button data-line="' + (i + 1) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Menos">-</button>' +
                        '<span>' + it.quantity + '</span>' +
                        '<button data-line="' + (i + 1) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Más">+</button></div></div>' +
                        '<button class="cart-remove" data-line="' + (i + 1) + '" data-qty="0">Quitar</button></div>';
                }).join('');
            }
            $('#cart-total-price').textContent = money(cart.total_price);
            $('#checkout-btn').disabled = !cart.items.length;
        });
    }

    function changeLine(line, qty) {
        return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
        }).then(function () { renderCart(); });
    }

    function addToCart(variantId, qty, btn) {
        if (!variantId) return;
        var original = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Agregando…'; }
        return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
        }).then(function (r) {
            if (!r.ok) throw new Error('add');
            return r.json();
        }).then(function () {
            toast('Producto agregado al carrito');
            return fetchCart().then(function (c) { updateCount(c); openCart(); });
        }).catch(function () {
            toast('No pudimos agregar el producto. Probá de nuevo.');
        }).then(function () {
            if (btn) { btn.disabled = false; btn.textContent = original; }
        });
    }

    $('#cart-btn').addEventListener('click', openCart);
    $('#cart-close-btn').addEventListener('click', closeCart);
    $('#cart-drawer-overlay').addEventListener('click', closeCart);
    $('#cart-continue-btn').addEventListener('click', closeCart);
    $('#checkout-btn').addEventListener('click', function () { window.location.href = '/checkout'; });
    $('#cart-items-container').addEventListener('click', function (e) {
        var b = e.target.closest('button[data-line]'); if (!b) return;
        changeLine(b.dataset.line, b.dataset.qty);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closePolicy(); } });
    if (location.hash === '#cart') { openCart(); history.replaceState(null, '', location.pathname); }
    fetchCart().then(updateCount);

    /* ---------- Tarjetas de catálogo ---------- */
    $$('.product-card[data-handle]').forEach(function (card) {
        var img = $('.card-main-img', card);
        var priceEl = $('.price', card);
        var buy = $('.buy-button', card);
        $$('[data-card-variants] button', card).forEach(function (b) {
            b.addEventListener('click', function () {
                $$('[data-card-variants] button', card).forEach(function (x) { x.classList.remove('active'); });
                b.classList.add('active');
                if (b.dataset.image && img) img.src = b.dataset.image;
                priceEl.textContent = b.dataset.priceText;
                card.dataset.price = b.dataset.price;
                buy.dataset.variantId = b.dataset.variantId;
                buy.dataset.image = b.dataset.image || buy.dataset.image;
            });
        });
        if (buy) buy.addEventListener('click', function () { addToCart(buy.dataset.variantId, 1, buy); });
    });

    /* ---------- Filtros y orden ---------- */
    var grid = $('#product-grid');
    if (grid) {
        var cards = $$('.product-card', grid);
        var current = 'all';
        function applyFilter() {
            cards.forEach(function (c) { c.classList.toggle('hidden', current !== 'all' && c.dataset.category !== current); });
        }
        $$('.filter-chip').forEach(function (chip) {
            chip.addEventListener('click', function () {
                $$('.filter-chip').forEach(function (c) { c.classList.remove('active'); });
                chip.classList.add('active'); current = chip.dataset.filter; applyFilter();
            });
        });
        /* Orden por defecto: consolas primero, luego controles, portátiles/VR, audio, accesorios y almacenamiento */
        var PRIORITY = ['ps5-slim-disc', 'ps5-slim-digital', 'ps5-pro', 'dualsense-wireless-controller', 'dualsense-edge', 'access-controller',
            'playstation-portal', 'ps-vr2', 'pulse-elite', 'pulse-explore', 'hd-camera', 'media-remote', 'dualsense-charging-station',
            'console-covers', 'disc-drive', 'wd-black-sn850p', 'seagate-game-drive'];
        function rank(c) { var i = PRIORITY.indexOf(c.dataset.handle); return i < 0 ? 999 + Number(c.dataset.index) : i; }
        function sortCards(mode) {
            var arr = cards.slice();
            if (mode === 'price-asc') arr.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
            else if (mode === 'price-desc') arr.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
            else arr.sort(function (a, b) { return rank(a) - rank(b); });
            arr.forEach(function (c) { grid.appendChild(c); });
        }
        sortCards('default');

        var dd = $('#sort-dropdown');
        if (dd) {
            var trigger = $('.sort-trigger', dd), label = $('#sort-label', dd);
            function setOpen(o) { dd.classList.toggle('open', o); trigger.setAttribute('aria-expanded', o ? 'true' : 'false'); }
            trigger.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!dd.classList.contains('open')); });
            $$('.sort-menu li', dd).forEach(function (li) {
                li.addEventListener('click', function () {
                    $$('.sort-menu li', dd).forEach(function (x) { x.classList.remove('selected'); });
                    li.classList.add('selected'); label.textContent = li.textContent;
                    sortCards(li.dataset.value); setOpen(false);
                });
            });
            document.addEventListener('click', function () { setOpen(false); });
            document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
        }
    }

    /* ---------- Página de producto ---------- */
    var single = $('#buy-btn-single');
    if (single) {
        var qty = 1, qEl = $('#single-qty-val');
        $('#qty-minus').addEventListener('click', function () { qty = Math.max(1, qty - 1); qEl.textContent = qty; });
        $('#qty-plus').addEventListener('click', function () { qty = Math.min(10, qty + 1); qEl.textContent = qty; });
        $$('.single-color-dot, .single-variant-chip').forEach(function (b) {
            b.addEventListener('click', function () {
                $$('.single-color-dot, .single-variant-chip').forEach(function (x) { x.classList.remove('active'); });
                b.classList.add('active');
                var main = $('#product-single-main-img');
                if (b.dataset.image && main) { main.style.opacity = 0; setTimeout(function () { main.src = b.dataset.image; main.style.opacity = 1; }, 120); }
                $('#single-price-display').textContent = b.dataset.price;
                var nm = $('#single-active-name'); if (nm) nm.textContent = b.dataset.name;
                single.dataset.variantId = b.dataset.variantId;
                var url = new URL(location.href); url.searchParams.set('variant', b.dataset.variantId);
                history.replaceState(null, '', url);
            });
        });
        single.addEventListener('click', function () { addToCart(single.dataset.variantId, qty, single); });
    }

    /* ---------- Modal de políticas ---------- */
    var policy = $('#policy-modal');
    function openPolicy(tab) { policy.classList.add('open'); selectTab(tab || 'ayuda'); }
    function closePolicy() { policy && policy.classList.remove('open'); }
    function selectTab(name) {
        $$('.policy-tab-btn').forEach(function (b) { b.classList.toggle('active', b.dataset.target === name); });
        $$('.policy-tab-content').forEach(function (c) { c.classList.toggle('active', c.id === 'tab-content-' + name); });
    }
    $$('.policy-tab-btn').forEach(function (b) { b.addEventListener('click', function () { selectTab(b.dataset.target); }); });
    $$('[data-tab]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openPolicy(a.dataset.tab); }); });
    $('#policy-close-btn').addEventListener('click', closePolicy);
    $('#policy-modal-overlay').addEventListener('click', closePolicy);
    $('#policy-modal-action-btn').addEventListener('click', closePolicy);

    /* ---------- WhatsApp widget ---------- */
    var wp = $('#wsp-popup'), wb = $('#wsp-float-btn');
    wb.addEventListener('click', function () {
        var open = wp.classList.toggle('open');
        wp.setAttribute('aria-hidden', open ? 'false' : 'true');
        var badge = $('#wsp-badge'); if (badge) badge.style.display = 'none';
    });
    $('#wsp-popup-close').addEventListener('click', function () { wp.classList.remove('open'); wp.setAttribute('aria-hidden', 'true'); });

    /* ---------- Reveal on scroll ---------- */
    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
        }, { threshold: 0.08 });
        $$('.reveal').forEach(function (el) { io.observe(el); });
    } else { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); }

    /* ---------- Navbar sombra al scroll ---------- */
    var nav = $('#main-navbar');
    window.addEventListener('scroll', function () {
        nav.style.boxShadow = window.scrollY > 10 ? '0 6px 24px rgba(11,16,32,.08)' : 'none';
    }, { passive: true });
})();
